import { ReactComponent as Icon } from './selectColumnIcon.svg'
import { theme } from '@ss/meta-core-components'
import React from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
}

export const SelectColumnIcon: React.FC<Props> = ({
  ariaLabel = 'select column',
  role = 'icon',
}) => {
  //todo:theme

  return (
    <Icon
      aria-label={ariaLabel}
      role={role}
      data-cy={'select-column-icon'}
      fill={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
    />
  )
}
